
const Mission=()=>{
    return(
        <div>
            <h>hi from Mission</h>
          
        </div>
    )
}

export default Mission;